import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import { faker } from "@faker-js/faker";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const options = {
  responsive: true,
  maintainAspectRatio: false,
  legend: {
    display: false,
  },
  plugins: {
    title: {
      display: false,
      text: "Class performance",
    },
    legend: {
      display: false,
    },
    datalabels: {
      display: false,
    },
  },
  scales: {
    x: {
      grid: {
        display: false,
      },
      ticks: {
        display: false,
      },
    },
    y: {
      grid: {
        display: false,
      },
      ticks: {
        display: false,
      },
    },
  },
};

const labels = ["January", "February", "March", "April"];

const data = {
  labels,

  datasets: [
    {
      label: "Dataset 1",
      display: false,
      data: labels.map(() => faker.datatype.number({ min: 1, max: 50 })),
      backgroundColor: "rgb(175, 166, 255)",
    },
  ],
};

export default function AttendChart() {
  return <Bar options={options} data={data} />;
}
